/* eslint-disable no-constant-condition */
import { all, call, fork, put, select, spawn, take, takeLatest } from 'redux-saga/effects'
import { api } from '../services'
import * as actions from '../actions'
import {
  getCardRequestOptions,
  getCartList,
  getIeList,
  getMemberRenew,
  getProfile,
  getShoppingCart,
  getStoreRenew,
  getUserInfo,
  getWechatUser,
  isRequesting,
} from '../reducers/selectors'
import { AUTH_COOKIE_MAX_AGE, delCookie, getCookie, getDataFromStorage, saveStorage, setCookie } from '../components/common/cookie'
import { getWechatOpenId } from '../utils/wechat'
import { LOCATION_CHANGE, push, replace } from 'connected-react-router'
import { getParameterByName, isEmpty, isWechat } from '../components/common/utils'
import { FUIOU_H5_PAY_TYPE, isValidFuiouUrl, pickFuiouChannel } from '../components/FormTools/utils'
import {
  bookSaleList,
  clearSignature,
  dmDetail,
  getCdSiAppListRequest,
  getCreditsRequest,
  getDetailOssFile,
  getDmOssFile,
  getInsDmOssFile,
  getOssFile,
  getSiAppDetailRequest,
  getSiAppListRequest,
  getSiDetailInProcessRequest,
  getSignatureRequest,
  getStudentInfoRequest,
  getUserPhotoRequest,
  instructorApplication,
  instructorConfirmDetail,
  submitDm,
  submitSignatureRequest,
  submitSiInprocessRequest,
  uploadAttachFile,
  uploadDetailAttachRequest,
  uploadDmAppFile,
  uploadFileRequest,
  uploadInsDmAppFile,
} from '../reducers/ui'
import { getOssSignatureRequest } from '../reducers/oss'
import {
  applicantDetail,
  getCdListRequest,
  getCourseReport,
  getOwsiOssFile,
  getOwsiTraining,
  ieCandidate,
  ieList,
  ieListForExaminer,
  owsiCdDetail,
  submitIeRequest,
  uploadCdTrainingToServer,
  uploadCourseReportToServer,
  uploadOwsiAttachFile,
  uploadOwsiTraining,
} from '../reducers/owsi'
import {
  efriDetail,
  efrtDetail,
  getEfrOssFile,
  getEfrtListRequest,
  getEfrtOssFile,
  uploadEfrAttachFile,
  uploadEfrtAttachFile,
} from '../reducers/efri'

import {
  basicMermaidDetail,
  basicMermaidTDetail,
  getBasicMermaidOssFile,
  getBasicMermaidTListRequest,
  getMermaidOssFile,
  getMermaidTListRequest,
  mermaidDetail,
  mermaidTDetail,
  uploadBasicMermaidAttachFile,
  uploadMermaidAttachFile,
} from '../reducers/mermaid'

import { FDIDetail, FDITDetail, getFDIOssFile, getFDITListRequest, uploadFDIAttachFile } from '../reducers/fdi'

import { getMFDIOssFile, getMFDITListRequest, MFDIDetail, MFDITDetail, uploadMFDIAttachFile } from '../reducers/mfdi'

import { AFDIDetail, AFDITDetail, getAFDIOssFile, getAFDITListRequest, uploadAFDIAttachFile } from '../reducers/afdi'
import { getReferer } from '../utils/env'

const {
  ecards,
  redeemedFreeCards,
  cardRequestOptions,
  pageLoading,
  pageLoaded,
  wechatUser,
  errorDialog,
  profile,
  skipRouter,
  skipPath,
  shoppingCart,
  submitSuccess,
  hasPigYearCard,
  registrationResult,
  noticeDisplay,
  noticeHide,
  verifyMobile,
  showToast,
  submitShoppingCart,
  memberRenew,
  storeRenew,
  memberRenewFuiouOrder,
  storeRenewFuiouOrder,
  clearCardRequestInfo,
  saveProfile,
  cdSubmitApp,
  refreshToken,
} = actions

const padiWxId = getCookie('padiWxId')

function* fetchEntity(entity, apiFn, ...rest) {
  yield put(entity.request(...rest))
  const result = yield call(apiFn, ...rest)
  const { data, error } = result
  if (data) {
    yield put(entity.success(data))
    return { data }
  }
  if (error) {
    yield put(entity.failure(error))
    const isPublicPreview = window.location.pathname.indexOf('/buy_cards_preview') >= 0
    if (window.location.pathname.indexOf('/authorize') < 0 && !isPublicPreview) {
      yield put(errorDialog(error.clientMsg))
    }
    if (
      (error.code === 'auth.required' ||
        error.code === 'expired.token' ||
        error.code === 'email.not.inm2' ||
        error.code === 'sys.auth.permission.denied') &&
      window.location.pathname.indexOf('/authorize') < 0 &&
      !isPublicPreview
    ) {
      const referer = getReferer()
      yield put(skipRouter(`/emailLogin?referer=${referer}`))
    } else if (error.code === 'renewal.member.fdi.need.efri') {
      yield put(skipRouter('/myProfile'))
    } else if (error.code === 'si.application.not.paid') {
      yield put(skipRouter('/specialtyApp'))
    }
    return { error }
  }
}

function* fetchEntityNoDialog(entity, apiFn, ...rest) {
  yield put(entity.request(...rest))
  const result = yield call(apiFn, ...rest)
  const { data, error } = result
  if (data) {
    yield put(entity.success(data))
    return { data }
  }
  if (error) {
    yield put(entity.failure(error))
    return { error }
  }
}

function* fetchEntityNotJson(entity, apiFn, ...rest) {
  yield put(entity.request(...rest))
  const { data, error } = yield call(apiFn, ...rest)
  if (error) {
    yield put(entity.failure(error))
    yield put(errorDialog(error.clientMsg))
    return { error }
  } else if (data.toString()) {
    yield put(entity.success(data))
    return data
  } else {
    yield put(entity.failure(error))
  }
}

function* postEntity(apiFn, notError, ...rest) {
  const { data, error } = yield call(apiFn, ...rest)
  if (error) {
    // skip router automatically
    if (error.code === 'email.not.verified') {
      yield put(skipRouter('/verifyEmail'))
    }
    yield put(pageLoaded())
    if (!notError) yield put(errorDialog(error.clientMsg))
  }
  return data
}

const fetchEcards = fetchEntity.bind(null, ecards, api.fetchEcards)
// 已兑免费首卡列表：失败不弹全局错误框（降级为继续展示免费标签，服务端归零权威兜底）
const fetchRedeemedFreeCards = fetchEntityNoDialog.bind(null, redeemedFreeCards, api.fetchRedeemedFreeFirstCards)
const fetchCardRequestOptions = fetchEntity.bind(null, cardRequestOptions, api.cardRequestOptions)
const fetchWechatUser = fetchEntity.bind(null, wechatUser, api.fetchWechatUser)
const fetchProfiles = fetchEntity.bind(null, profile, api.fetchProfiles)
const postVerifyEmail = postEntity.bind(null, api.verifyEmailCode, false)
const postVerifyMobile = fetchEntity.bind(null, verifyMobile, api.verifyMobileCode)
const fetchSaveProfile = fetchEntity.bind(null, saveProfile, api.saveProfile)
const fetchShoppingCart = fetchEntity.bind(null, shoppingCart, api.fetchShoppingCart)
const fetchSubmitShoppingCart = fetchEntity.bind(null, submitShoppingCart, api.addToCart)
const credentialRequest = postEntity.bind(null, api.credentialRequest, false)
const fetchHasAnimalYearCard = fetchEntityNotJson.bind(null, hasPigYearCard, api.hasActivityCard)
const fetchMemberRenew = fetchEntity.bind(null, memberRenew, api.getMemberRenew)
const fetchStoreRenew = fetchEntity.bind(null, storeRenew, api.getStoreRenew)
const fetchMemberRenewFuiouOrder = fetchEntity.bind(null, memberRenewFuiouOrder, api.getMemberRenewFuiouOrder)
const fetchStoreRenewFuiouOrder = fetchEntity.bind(null, storeRenewFuiouOrder, api.getStoreRenewFuiouOrder)
const fetchSubmitDm = fetchEntity.bind(null, submitDm, api.submitDm)
const fetchBookSaleList = fetchEntity.bind(null, bookSaleList, api.getTextBookSaleList)

const fetchDmDetail = fetchEntity.bind(null, dmDetail, api.getDmDetail)
const fetchInstructorApplication = fetchEntity.bind(null, instructorApplication, api.instructorApplication)
const fetchInstructorComfirmDetail = fetchEntity.bind(null, instructorConfirmDetail, api.instructorApplicationDetail)
const postInstructorApproved = postEntity.bind(null, api.instructorApproved, false)
const fetchOssSignature = fetchEntity.bind(null, getOssSignatureRequest, api.getOssSignature)
const fetchSubmitDmSignature = fetchEntity.bind(null, submitSignatureRequest, api.uploadSignature)
const fetchSignatureOssUrl = fetchEntity.bind(null, getSignatureRequest, api.getOssFile)
const fetchUserPhoto = fetchEntityNoDialog.bind(null, getUserPhotoRequest, api.getUserPhoto)
const fetchUploadSiFile = fetchEntity.bind(null, uploadAttachFile, api.uploadSiFile)
const fetchUploadSiDetailAttach = fetchEntity.bind(null, uploadDetailAttachRequest, api.uploadSiFile)
const fetchUploadPhoto = fetchEntityNoDialog.bind(null, uploadFileRequest, api.uploadPhoto)
const fetchSiDetail = fetchEntity.bind(null, getSiAppDetailRequest, api.getSiAppDetail)
const fetchSiAppList = fetchEntity.bind(null, getSiAppListRequest, api.getSiAppList)
const fetchSiDetailInProcess = fetchEntity.bind(null, getSiDetailInProcessRequest, api.getSiDetailInProcess)
const fetchSubmitSiInprocess = fetchEntity.bind(null, submitSiInprocessRequest, api.submitSiInprocess)
const fetchSearchInstructorInfo = fetchEntity.bind(null, getStudentInfoRequest, api.getInstructorInfoByNumber)
const fetchCdSubmitSiApp = fetchEntity.bind(null, cdSubmitApp, api.cdSubmitSiApp)
const fetchCdSiAppList = fetchEntity.bind(null, getCdSiAppListRequest, api.cdSiAppList)
const fetchCdSiDetail = fetchEntity.bind(null, getSiDetailInProcessRequest, api.getCdSiDetail)
const fetchReSubmitCdSiInprocess = fetchEntity.bind(null, submitSiInprocessRequest, api.reSubmitCdSiApp)
const fetchGetOssFile = fetchEntity.bind(null, getOssFile, api.getOssFile)
const fetchGetDetailOssFile = fetchEntity.bind(null, getDetailOssFile, api.getOssFile)
const fetchGetCredits = fetchEntity.bind(null, getCreditsRequest, api.checkPrerequisiteRequirements)
const fetchRefreshToken = fetchEntity.bind(null, refreshToken, api.refreshToken)
const fetchOwsiDetail = fetchEntity.bind(null, applicantDetail, api.getOwsiDetail)
const fetchGetDmOssFile = fetchEntity.bind(null, getDmOssFile, api.getOssFile)
const fetchGetInsDmOssFile = fetchEntity.bind(null, getInsDmOssFile, api.getOssFile)
const fetchUploadDmFile = fetchEntity.bind(null, uploadDmAppFile, api.uploadSiFile)
const fetchUploadInsDmFile = fetchEntity.bind(null, uploadInsDmAppFile, api.uploadSiFile)
const fetchUploadOwsiFile = fetchEntity.bind(null, uploadOwsiAttachFile, api.uploadSiFile)
const fetchGetOwsiOssFile = fetchEntity.bind(null, getOwsiOssFile, api.getOssFile)
const fetchGetCourseReportFile = fetchEntity.bind(null, getCourseReport, api.getOssFile)
const fetchOwsiCdList = fetchEntity.bind(null, getCdListRequest, api.getOwsiCdList)
const fetchOwsiCdDetail = fetchEntity.bind(null, owsiCdDetail, api.getOwsiCdDetail)
const fetchIeList = fetchEntity.bind(null, ieList, api.getIeList)
const fetchIeCandidateList = fetchEntity.bind(null, ieCandidate, api.getIeCandidateList)
const fetchSubmitIe = fetchEntity.bind(null, submitIeRequest, api.submitIe)
const fetchUploadOwsiTraining = fetchEntity.bind(null, uploadOwsiTraining, api.uploadSiFile)
const fetchUploadCdTrainingToServer = fetchEntity.bind(null, uploadCdTrainingToServer, api.uploadTrainingRecord)
const fetchUploadCourseReportToServer = fetchEntity.bind(null, uploadCourseReportToServer, api.uploadCourseReport)
const fetchGetOwsiTraining = fetchEntity.bind(null, getOwsiTraining, api.getOssFile)
const fetchEfriDetail = fetchEntity.bind(null, efriDetail, api.getEfriDetail)
const fetchEfrtList = fetchEntity.bind(null, getEfrtListRequest, api.getEfrtList)
const fetchEfrtDetail = fetchEntity.bind(null, efrtDetail, api.getEFRTDetailByCode)
const fetchUploadEfrOssFile = fetchEntity.bind(null, uploadEfrAttachFile, api.uploadSiFile)
const fetchGetEfriOssFile = fetchEntity.bind(null, getEfrOssFile, api.getOssFile)
const fetchUploadEfrtOssFile = fetchEntity.bind(null, uploadEfrtAttachFile, api.uploadSiFile)
const fetchGetEfrtOssFile = fetchEntity.bind(null, getEfrtOssFile, api.getOssFile)
const fetchIeListForExaminer = fetchEntity.bind(null, ieListForExaminer, api.ieListForExaminer)
const fetchBasicMermaidDetail = fetchEntity.bind(null, basicMermaidDetail, api.basicMermaidDetail)
const fetchUploadBasicMermaidFile = fetchEntity.bind(null, uploadBasicMermaidAttachFile, api.uploadSiFile)
const fetchGetBasicMermaidOssFile = fetchEntity.bind(null, getBasicMermaidOssFile, api.getOssFile)
const fetchBasicMermaidTList = fetchEntity.bind(null, getBasicMermaidTListRequest, api.getBasicMermaidTList)
const fetchBasicMermaidTDetail = fetchEntity.bind(null, basicMermaidTDetail, api.getBasicMermaidTDetail)
const fetchMermaidiDetail = fetchEntity.bind(null, mermaidDetail, api.mermaidiDetail)
const fetchUploadMermaidFile = fetchEntity.bind(null, uploadMermaidAttachFile, api.uploadSiFile)
const fetchGetMermaidOssFile = fetchEntity.bind(null, getMermaidOssFile, api.getOssFile)
const fetchMermaidTList = fetchEntity.bind(null, getMermaidTListRequest, api.getMermaidTList)
const fetchMermaidTDetail = fetchEntity.bind(null, mermaidTDetail, api.getMermaidTDetail)
const fetchFdiDetail = fetchEntity.bind(null, FDIDetail, api.getFdiDetail)
const fetchUploadFdiFile = fetchEntity.bind(null, uploadFDIAttachFile, api.uploadSiFile)
const fetchGetFdiOssFile = fetchEntity.bind(null, getFDIOssFile, api.getOssFile)
const fetchFdiTList = fetchEntity.bind(null, getFDITListRequest, api.getFdiTList)
const fetchFdiTDetail = fetchEntity.bind(null, FDITDetail, api.getFdiTDetail)
const fetchAfdiDetail = fetchEntity.bind(null, AFDIDetail, api.getAfdiDetail)
const fetchUploadAfdiFile = fetchEntity.bind(null, uploadAFDIAttachFile, api.uploadSiFile)
const fetchGetAfdiOssFile = fetchEntity.bind(null, getAFDIOssFile, api.getOssFile)
const fetchAfdiTList = fetchEntity.bind(null, getAFDITListRequest, api.getAfdiTList)
const fetchAfdiTDetail = fetchEntity.bind(null, AFDITDetail, api.getAfdiTDetail)
const fetchMfdiDetail = fetchEntity.bind(null, MFDIDetail, api.getMfdiDetail)
const fetchUploadMfdiFile = fetchEntity.bind(null, uploadMFDIAttachFile, api.uploadSiFile)
const fetchGetMfdiOssFile = fetchEntity.bind(null, getMFDIOssFile, api.getOssFile)
const fetchMfdiTList = fetchEntity.bind(null, getMFDITListRequest, api.getMfdiTList)
const fetchMfdiTDetail = fetchEntity.bind(null, MFDITDetail, api.getMfdiTDetail)

function* loadEcardsList() {
  const padiWxId = getCookie('padiWxId')
  if (!padiWxId) return
  const diver = yield select(getUserInfo)

  const requesting = yield select(isRequesting, actions.ECARDS)

  if (!diver && !requesting) {
    yield call(loadEcards)
  }
}

// 已兑免费首卡列表：与 loadEcardsList 不同，不设 diver 守卫——ecards 在 userInfo 已加载后
// 导航不再重拉，但已兑列表必须每次进入购卡/购物袋页都拉（下单占用后返回页面的标签即时性）。
function* loadRedeemedFreeCards() {
  const padiWxId = getCookie('padiWxId')
  if (!padiWxId) return
  const requesting = yield select(isRequesting, actions.REDEEMED_FREE_CARDS)
  if (!requesting) {
    yield call(fetchRedeemedFreeCards)
  }
}

function* loadEcards() {
  const profiles = yield call(loadProfile)
  if (!profiles) return
  const { profile } = profiles
  const ecardsStorage = JSON.parse(getDataFromStorage(`ecards_${profile.email}`))

  if (ecardsStorage) {
    yield put(actions.refreshEcards(ecardsStorage))
    yield spawn(fetchEcardsAndSave, profile.email, ecardsStorage.data)
  } else {
    yield call(fetchEcardsAndSave, profile.email)
  }
}

function* fetchEcardsAndSave(email, saved) {
  const { data } = yield call(fetchEcards)
  if (data) {
    saveStorage(`ecards_${email}`, JSON.stringify(data))
    if (
      saved &&
      (saved.credentials.length !== data.credentials.length || saved.certifications !== data.certifications.length)
    ) {
      yield put(noticeDisplay('common-updateCerts'))
    }
  }
  return data
}

function* loadProfile() {
  const profiles = yield select(getProfile)
  if (!profiles) {
    const result = yield call(fetchProfiles)
    return result.data
  } else {
    return profiles
  }
}

function* loadBookSaleList() {
  const result = yield call(fetchBookSaleList)
  return result.data
}

function* loadWechatUser() {
  const wechatUser = yield select(getWechatUser)
  if (!wechatUser) yield call(fetchWechatUser)
}

function* loadCardRequestOptions(id) {
  const options = yield select(getCardRequestOptions, id)
  const requesting = yield select(isRequesting, actions.CARDREQUESTOPTIONS)
  if (!options && !requesting) {
    yield call(fetchCardRequestOptions, id)
  }
}

function* loadShoppingCart() {
  const shoppingCart = yield select(getShoppingCart)
  if (!shoppingCart) yield call(fetchShoppingCart)
}

function* loadMemberRenew() {
  const memberRenew = yield select(getMemberRenew)
  if (isEmpty(memberRenew)) return yield call(fetchMemberRenew)
}

function* loadStoreRenew() {
  const storeRenew = yield select(getStoreRenew)
  if (!storeRenew.length > 0) return yield call(fetchStoreRenew)
}

function* watchNavigate() {
  while (true) {
    const {
      payload: {
        location: { pathname },
      },
    } = yield take(LOCATION_CHANGE)
    if (
      pathname.indexOf('/myProfile') === 0 ||
      pathname.indexOf('/members') === 0 ||
      pathname === '/vip_change_ecards' ||
      pathname.indexOf('/cert/') === 0 ||
      pathname === '/campaign' ||
      pathname.indexOf('/cart') === 0
    ) {
      yield put(pageLoading())
      yield call(loadEcardsList)
      yield call(loadRedeemedFreeCards)
      yield put(pageLoaded())
    }
    if (pathname === '/newYearCampaign') {
      try {
        yield call(loadEcardsList)
      } catch (error) {
        yield put(errorDialog())
      }
    }
    if (pathname.indexOf('/addressForm') === 0) {
      yield take(actions.SUBMIT_SUCCESS)
      yield put(push('/certs'))
    }
    if (pathname.indexOf('/renew/') === 0) {
      yield put(pageLoading())
      if (pathname.indexOf('member') > 0) {
        yield call(loadMemberRenew)
      } else if (pathname.indexOf('store') > 0) {
        yield call(loadStoreRenew)
      }
      yield put(pageLoaded())
    }
    if (pathname === '/dmForm') {
      yield put(pageLoading())
      yield call(fetchDmDetail)
      yield call(loadEcardsList)
      yield put(pageLoaded())
    }
    if (pathname === '/bookSaleList') {
      yield put(pageLoading())
      yield call(loadProfile)
      yield call(loadBookSaleList)
      yield put(pageLoaded())
    }

    if (pathname === '/dmForInstructor') {
      yield put(pageLoading())
      yield put(clearSignature())
      const data = {
        code: getParameterByName('code'),
      }
      yield call(loadEcardsList)
      yield call(fetchInstructorComfirmDetail, data)
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/confirmApps') === 0) {
      yield put(pageLoading())
      yield call(fetchInstructorApplication, { page: 1 })
      yield put(pageLoaded())
    }
    if (pathname === '/specialtyApp') {
      yield put(pageLoading())
      yield all([
        yield call(fetchSiDetail),
        yield fork(fetchOssSignature, 'SI'),
        yield fork(fetchGetCredits),
        yield call(loadEcardsList),
      ])
      yield put(pageLoaded())
    }
    if (pathname === '/siAppList') {
      yield put(pageLoading())
      yield call(fetchSiAppList)
      yield call(loadEcardsList)
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/siAppDetail') === 0) {
      const credentialId = getParameterByName('credentialId')
      const code = getParameterByName('code')
      yield put(pageLoading())
      yield all([
        yield call(fetchSiDetailInProcess, { credentialId, code }),
        yield fork(fetchOssSignature, 'SI'),
        yield fork(fetchGetCredits),
        yield call(loadEcardsList),
      ])
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/cdAppForm') === 0) {
      yield put(pageLoading())
      yield all([yield call(fetchOssSignature, 'SI'), yield call(loadEcardsList)])
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/cdAppList') === 0) {
      yield put(pageLoading())
      yield all([yield call(fetchCdSiAppList), yield call(loadEcardsList)])
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/cdAppDetail') === 0) {
      const credentialId = getParameterByName('credentialId')
      const code = getParameterByName('code')
      yield put(pageLoading())
      yield all([yield call(fetchCdSiDetail, { credentialId, code }), yield fork(fetchOssSignature, 'SI')])
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/owsi_app') === 0 || pathname.indexOf('/ie_resit') === 0) {
      yield put(pageLoading())
      yield all([
        yield call(fetchOssSignature, 'OWSI'),
        yield call(fetchOwsiDetail),
        yield call(fetchIeList),
        yield call(loadEcardsList),
      ])
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/owsi_cd_apps') === 0) {
      yield put(pageLoading())
      yield call(fetchOwsiCdList, { page: 1 })
      yield put(pageLoaded())
    }
    if (pathname === '/owsi_cd_app_detail') {
      yield put(pageLoading())
      yield put(clearSignature())
      const code = getParameterByName('code')
      yield all([yield call(fetchOwsiCdDetail, { code }), yield call(loadEcardsList)])
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/efri_app') === 0) {
      yield put(pageLoading())
      yield all([yield fork(fetchOssSignature, 'EFRI'), yield call(fetchEfriDetail), yield call(loadEcardsList)])
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/efrt_list') === 0) {
      yield put(pageLoading())
      yield call(fetchEfrtList, { page: 1 })
      yield put(pageLoaded())
    }
    if (pathname === '/efrt_detail') {
      yield put(pageLoading())
      yield put(clearSignature())
      const code = getParameterByName('code')
      yield all([yield call(fetchEfrtDetail, code), yield call(loadEcardsList), yield fork(fetchOssSignature, 'EFRI')])
      yield put(pageLoaded())
    }
    if (pathname === '/basic_mermaid_app') {
      yield put(pageLoading())
      yield all([
        yield call(fetchBasicMermaidDetail),
        yield call(loadEcardsList),
        yield fork(fetchOssSignature, 'PADI_BASIC_MERMAID_I'),
      ])
      yield put(pageLoaded())
    }
    if (pathname === '/ie_list') {
      yield put(pageLoading())
      yield call(fetchIeList)
      yield put(pageLoaded())
    }
    if (pathname.indexOf('ie_candidate_list') >= 0) {
      const ieId = getParameterByName('ie_id')
      yield put(pageLoading())
      yield call(fetchIeCandidateList, ieId)
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/resources_collection') >= 0) {
      yield put(pageLoading())
      yield all([
        // yield call(loadEcardsList),
        yield call(fetchOssSignature, 'COLLECTION'),
      ])
      yield put(pageLoaded())
    }
    if (pathname.indexOf('/ie_exam_attempts') >= 0) {
      const ieList = yield select(getIeList)
      if (!ieList || ieList.length === 0) {
        yield put(pageLoading())
        yield call(fetchIeListForExaminer)
        yield put(pageLoaded())
      }
    }
    if (pathname === '/basic_mermaid_app_list') {
      yield put(pageLoading())
      yield call(fetchBasicMermaidTList, { page: 1 })
      yield put(pageLoaded())
    }
    if (pathname === '/basic_mermaid_app_detail') {
      yield put(pageLoading())
      yield put(clearSignature())
      const code = getParameterByName('code')
      yield all([
        yield call(fetchBasicMermaidTDetail, code),
        yield call(loadEcardsList),
        yield fork(fetchOssSignature, 'PADI_BASIC_MERMAID_I'),
      ])
      yield put(pageLoaded())
    }
    if (pathname === '/mermaidi_app') {
      yield put(pageLoading())
      yield all([
        yield call(fetchMermaidiDetail),
        yield call(loadEcardsList),
        yield fork(fetchOssSignature, 'PADI_MERMAID_I'),
      ])
      yield put(pageLoaded())
    }
    if (pathname === '/mermaid_app_list') {
      yield put(pageLoading())
      yield call(fetchMermaidTList, { page: 1 })
      yield put(pageLoaded())
    }
    if (pathname === '/mermaid_app_detail') {
      yield put(pageLoading())
      yield put(clearSignature())
      const code = getParameterByName('code')
      yield all([
        yield call(fetchMermaidTDetail, code),
        yield call(loadEcardsList),
        yield fork(fetchOssSignature, 'PADI_MERMAID_I'),
      ])
      yield put(pageLoaded())
    }
    if (pathname === '/fdi_app') {
      yield put(pageLoading())
      yield all([yield call(fetchFdiDetail), yield call(loadEcardsList), yield fork(fetchOssSignature, 'FDI')])
      yield put(pageLoaded())
    }
    if (pathname === '/fdi_app_list') {
      yield put(pageLoading())
      yield call(fetchFdiTList, { page: 1 })
      yield put(pageLoaded())
    }
    if (pathname === '/fdi_app_detail') {
      yield put(pageLoading())
      yield put(clearSignature())
      const code = getParameterByName('code')
      yield all([yield call(fetchFdiTDetail, code), yield call(loadEcardsList), yield fork(fetchOssSignature, 'FDI')])
      yield put(pageLoaded())
    }
    if (pathname === '/afdi_app') {
      yield put(pageLoading())
      yield all([yield call(fetchAfdiDetail), yield call(loadEcardsList), yield fork(fetchOssSignature, 'AFDI')])
      yield put(pageLoaded())
    }
    if (pathname === '/afdi_app_list') {
      yield put(pageLoading())
      yield call(fetchAfdiTList, { page: 1 })
      yield put(pageLoaded())
    }
    if (pathname === '/afdi_app_detail') {
      yield put(pageLoading())
      yield put(clearSignature())
      const code = getParameterByName('code')
      yield all([yield call(fetchAfdiTDetail, code), yield call(loadEcardsList), yield fork(fetchOssSignature, 'AFDI')])
      yield put(pageLoaded())
    }
    if (pathname === '/mfdi_app') {
      yield put(pageLoading())
      yield all([yield call(fetchMfdiDetail), yield call(loadEcardsList), yield fork(fetchOssSignature, 'MFDI')])
      yield put(pageLoaded())
    }
    if (pathname === '/mfdi_app_list') {
      yield put(pageLoading())
      yield call(fetchMfdiTList, { page: 1 })
      yield put(pageLoaded())
    }
    if (pathname === '/mfdi_app_detail') {
      yield put(pageLoading())
      yield put(clearSignature())
      const code = getParameterByName('code')
      yield all([yield call(fetchMfdiTDetail, code), yield call(loadEcardsList), yield fork(fetchOssSignature, 'MFDI')])
      yield put(pageLoaded())
    }
    if (pathname === '/pockets_apps' || pathname === '/issue_certs/detail') {
      yield put(pageLoading())
      yield call(loadEcardsList)
      yield put(pageLoaded())
    }
    if (pathname === '/books_checkout' || pathname === '/agent_elearning') {
      yield put(pageLoading())
      yield call(loadProfile)
      yield put(pageLoaded())
    }
    if (pathname === '/club_ecards' || pathname === '/buy_cards') {
      yield put(pageLoading())
      yield call(loadEcardsList)
      yield call(loadRedeemedFreeCards)
      yield put(pageLoaded())
    }
    if (pathname === '/register') {
      delCookie('padiWxId')
    }
  }
}

function* watchLoadEcards() {
  while (true) {
    yield take(actions.LOAD_ECARDS_PAGE)
    yield put(pageLoading())
    try {
      const padiWxId = getCookie('padiWxId')
      if (!padiWxId) return
      const profiles = yield call(loadProfile)

      if (profiles && !profiles.error) {
        yield call(loadEcardsList)
        if (isWechat()) {
          const token = yield call(fetchRefreshToken)
          if (token.data) {
            setCookie('wechatToken', token.data.idToken, undefined, undefined, AUTH_COOKIE_MAX_AGE)
          }
        }
      }
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchWechatUser() {
  while (true) {
    yield take(actions.REQUEST_WECHAT_USER)
    yield put(pageLoading())
    yield put(noticeHide())
    if (padiWxId && padiWxId.length < 30) yield call(loadWechatUser)
    yield put(pageLoaded())
  }
}

function* watchEmailCode() {
  while (true) {
    const requestCode = yield take(actions.REQUEST_EMAIL_CODE)
    try {
      yield call(api.getEmailCode, requestCode.email)
    } catch (error) {
      yield put(errorDialog())
    }
  }
}

function* watchVerifyEmail() {
  while (true) {
    const verifyEmail = yield take(actions.VERIFY_EMAIL_CODE)
    yield put(pageLoading())
    try {
      yield call(fetchProfiles, verifyEmail.data.email)
      const data = yield call(postVerifyEmail, verifyEmail.data)
      if (data === true) {
        const profile = yield select(getProfile)
        const profileData = { email: profile.profile.email }
        yield call(fetchSaveProfile, profileData)
        yield put(pageLoaded())
        yield put(push('/setMobile'))
      }
    } catch (error) {
      yield put(pageLoaded())
      yield put(errorDialog())
    }
  }
}

function* watchPostProfile() {
  while (true) {
    yield take(actions.POST_PROFILE)
    yield put(pageLoading())
    const profile = yield select(getProfile)
    const profileData = {
      email: profile.profile.email,
      countryCode: profile.profile.countryCode,
      mobile: profile.profile.mobile,
      firstName: profile.profile.firstName,
      lastName: profile.profile.lastName,
      birthDate: profile.profile.birthDate,
      gender: profile.profile.gender,
    }
    try {
      const { data } = yield call(fetchSaveProfile, profileData)
      if (data) {
        if (data.profileId) {
          yield put(pageLoaded())
          yield put(push('/setPassword'))
        }
      }
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchPostPassword() {
  while (true) {
    yield take(actions.POST_PASSWORD)
    yield put(pageLoading())
    const profile = yield select(getProfile)
    const profileData = {
      email: profile.profile.email,
      countryCode: profile.profile.countryCode,
      mobile: profile.profile.mobile,
      password: profile.profile.password,
      firstName: profile.profile.firstName,
      lastName: profile.profile.lastName,
      birthDate: profile.profile.birthDate,
      gender: profile.profile.gender,
    }
    try {
      const { data } = yield call(fetchSaveProfile, profileData)
      if (data) {
        if (data.profileId) {
          yield put(registrationResult(false))
          yield put(push('/registrationSuccess'))
        } else {
          yield put(push('/registrationFailure'))
        }
      }
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchMobileCode() {
  while (true) {
    const requestCode = yield take(actions.REQUEST_MOBILE_CODE)
    try {
      yield call(api.getMobileCode, requestCode)
    } catch (error) {
      yield put(errorDialog())
    }
  }
}

function* watchVerifyMobile() {
  while (true) {
    const verifyMobile = yield take(actions.VERIFY_MOBILE_CODE)
    yield put(pageLoading())
    try {
      const { data } = yield call(postVerifyMobile, verifyMobile.data)
      if (data) {
        const { verifyMobileCode } = data
        if (verifyMobileCode === true) {
          const profile = yield select(getProfile)
          const profileData = {
            email: profile.profile.email,
            countryCode: profile.profile.countryCode,
            mobile: profile.profile.mobile,
          }
          const { data } = yield call(fetchSaveProfile, profileData)
          if (data.affiliateId <= 0) {
            yield put(pageLoaded())
            yield put(push('/set_profile'))
            return
          }
          if (data.ssoType === 'NONE') {
            yield put(pageLoaded())
            yield put(push('/setPassword'))
          } else if (data.ssoType === 'EMAIL' || data.ssoType === 'MOBILE') {
            yield put(registrationResult(true))
            yield put(pageLoaded())
            yield put(push('/registrationSuccess'))
          } else {
            yield put(pageLoaded())
            yield put(push('/registrationFailure'))
          }
        }
      }
    } catch (error) {
      yield put(pageLoaded())
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchShoppingCart() {
  while (true) {
    yield take(actions.ADD_TO_CART)
    const items = yield select(getCartList)
    try {
      yield call(fetchSubmitShoppingCart, items)
    } catch (error) {
      yield put(errorDialog())
    }
  }
}

function* watchRequestHasPigYearCard() {
  while (true) {
    yield take(actions.REQUEST_HAS_PIG_YEAR_CARD)
    yield put(pageLoading())
    try {
      yield call(fetchHasAnimalYearCard, 15)
    } catch (e) {
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchToPigCard() {
  while (true) {
    yield take(actions.TO_PIG_CARD)
    yield put(pageLoading())
    try {
      const result = yield call(fetchHasAnimalYearCard, 15)
      if (result.binded) {
        const language = getCookie('language')
        yield put(showToast(''))
        if (language === 'tc') yield put(showToast('您已領取蛇年生肖卡'))
        else yield put(showToast('您已领取蛇年生肖卡'))
      } else {
        yield put(push('/newYearCampaign'))
      }
    } catch (e) {
      console.error(e)
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchDelectCartItem() {
  while (true) {
    yield take(actions.DELECT_CART_ITEM)
    const items = yield select(getCartList)
    try {
      yield call(fetchSubmitShoppingCart, items)
    } catch (error) {
      yield put(errorDialog())
    }
  }
}

function* watchCredentialRequest() {
  while (true) {
    const {
      data: { ecardId },
    } = yield take(actions.CREDENTIAL_REQUEST)
    try {
      yield put(pageLoading())
      const result = yield call(credentialRequest, ecardId)
      if (result) {
        const language = getCookie('language')
        if (language === 'tc') yield put(showToast('您的實體卡申請成功提交，請耐心等候。'))
        else yield put(showToast('您的实体卡申请成功提交，请耐心等候。'))
      }
      yield put(submitSuccess())
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchReplaceCard() {
  while (true) {
    yield take(actions.REPLACE_CARD)
    const cartList = yield select(getCartList)
    try {
      yield call(fetchSubmitShoppingCart, cartList)
    } catch (error) {
      yield put(errorDialog())
    }
  }
}

function* watchGetYouzanMobileCode() {
  while (true) {
    const {
      data: { mobile },
    } = yield take(actions.REQUEST_YOUZAN_MOBILE_CODE)
    try {
      yield call(api.getYouzanMobileCode, mobile)
    } catch (error) {
      yield put(errorDialog())
    }
  }
}

function* watchRequestShoppingCart() {
  while (true) {
    yield take(actions.REQUEST_SHOPPING_CART)
    yield put(pageLoading())
    try {
      yield call(loadShoppingCart)
      yield put(pageLoaded())
    } catch (error) {
      yield put(pageLoaded())
      yield put(errorDialog())
    }
  }
}

// 续费富友下单 worker：takeLatest 防止请求期间重复点击造成重复下单
function* submitMemberRenewWorker({ data: withEfri, payType }) {
  // data = 用户所选项的 isEfr（true=核心+EFRI，false=仅核心），作为 withEfri 透传后端定价/收款
  try {
    yield put(pageLoading())
    const channel = pickFuiouChannel()
    // 续费 payType 必填（null/空 → payment.payType.invalid）：
    // H5PAY（公众号内调起）→ WeJsapiPay（2026-08-17 统一，原 JSAPI 兼容值不在富友 H5 官方值域，
    // 后端 RenewalService 白名单已确认支持）；WPOS（PC 扫码）→ 组件层先选渠道后传入 WECHAT/ALIPAY 单码
    const resolvedPayType = channel === 'H5PAY' ? FUIOU_H5_PAY_TYPE.WECHAT_JSAPI : payType
    // openid 必传（后端不从 session 解析）：取微信登录态（PC 单码扫码无登录态时为 undefined）
    const result = yield call(fetchMemberRenewFuiouOrder, {
      channel,
      payType: resolvedPayType,
      withEfri,
      openid: getWechatOpenId(),
    })
    if (result.data && result.data.url) {
      if (channel === 'H5PAY') {
        if (isValidFuiouUrl(result.data.url)) {
          window.location.replace(result.data.url)
        } else {
          yield put(errorDialog())
        }
      }
      // WPOS 时 fetchEntity 已自动 dispatch success 到 Redux，
      // 组件通过 selector 读取 fuiouOrderData 后渲染 QR 弹窗
    } else if (!result.error) {
      // 后端成功返回但缺 url 时兜底提示；请求失败时 fetchEntity 已弹错误框（含具体错误信息），
      // 这里不再重复弹，避免二次弹窗把具体信息覆盖成通用"系统出错"
      yield put(errorDialog())
    }
  } catch (error) {
    yield put(errorDialog())
  } finally {
    yield put(pageLoaded())
  }
}

function* watchSubmitMemberRenew() {
  yield takeLatest(actions.SUBMIT_MEMBER_RENEW, submitMemberRenewWorker)
}

function* submitStoreRenewWorker({ payType }) {
  try {
    yield put(pageLoading())
    const channel = pickFuiouChannel()
    // 续费 payType 必填（null/空 → payment.payType.invalid）：
    // H5PAY（公众号内调起）→ WeJsapiPay（原 JSAPI 兼容值已统一，同会员续费）；
    // WPOS（PC 扫码）→ 组件层先选渠道后传入 WECHAT/ALIPAY 单码
    const resolvedPayType = channel === 'H5PAY' ? FUIOU_H5_PAY_TYPE.WECHAT_JSAPI : payType
    // openid 必传（后端不从 session 解析）：取微信登录态（PC 单码扫码无登录态时为 undefined）
    const result = yield call(fetchStoreRenewFuiouOrder, {
      channel,
      payType: resolvedPayType,
      openid: getWechatOpenId(),
    })
    if (result.data && result.data.url) {
      if (channel === 'H5PAY') {
        if (isValidFuiouUrl(result.data.url)) {
          window.location.replace(result.data.url)
        } else {
          yield put(errorDialog())
        }
      }
      // WPOS 时 fetchEntity 已自动 dispatch success 到 Redux，
      // 组件通过 selector 读取 fuiouOrderData 后渲染 QR 弹窗
    } else if (!result.error) {
      // 后端成功返回但缺 url 时兜底提示；请求失败时 fetchEntity 已弹错误框（含具体错误信息），
      // 这里不再重复弹，避免二次弹窗把具体信息覆盖成通用"系统出错"
      yield put(errorDialog())
    }
  } catch (error) {
    yield put(errorDialog())
  } finally {
    yield put(pageLoaded())
  }
}

function* watchSubmitStoreRenew() {
  yield takeLatest(actions.SUBMIT_STORE_RENEW, submitStoreRenewWorker)
}

function* watchRequestMemberRenew() {
  while (true) {
    yield take(actions.REQUEST_MEMBER_RENEW)
    yield put(pageLoading())
    try {
      yield select(loadMemberRenew)
      yield put(push('/renew/member'))
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchRequestCardOptionspage() {
  while (true) {
    const { data } = yield take(actions.REQUEST_CARD_OPTIONS_PAGE)
    try {
      yield put(pageLoading())
      yield put(clearCardRequestInfo())
      yield spawn(loadShoppingCart)
      yield call(loadCardRequestOptions, data)
      yield call(loadEcardsList)
      yield put(actions.addEcardData(data))
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchUploadDmFile() {
  while (true) {
    const { payload } = yield take('dmDetail/uploadDmFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadDmFile, payload)
    if (data) yield call(fetchGetDmOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchUploadInsDmFile() {
  while (true) {
    const { payload } = yield take('instructorConfirmDetail/uploadInsDmFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadInsDmFile, payload)
    if (data) yield call(fetchGetInsDmOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchRequestDmConfirmDetail() {
  while (true) {
    const { payload } = yield take('instructorConfirmDetail/requestConfirmDetail')
    yield put(pageLoading())
    try {
      const { data } = yield call(fetchInstructorComfirmDetail, payload)
      if (data) yield put(push(`/dmForInstructor?code=${payload.code}`))
    } catch (error) {
      console.error(error)
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchInstructorApproved() {
  while (true) {
    const { data } = yield take(actions.INSTRUCTOR_APPROVED)
    yield put(pageLoading())
    const result = yield call(postInstructorApproved, data)
    yield put(pageLoaded())
    if (result) yield put(replace('/confirmApps'))
  }
}

function* watchSubmitSignature() {
  while (true) {
    const { payload } = yield take('signature/submitSignature')
    const key = payload.formData.get('key')
    yield put(pageLoading())
    const { data } = yield call(fetchSubmitDmSignature, payload)
    if (data) {
      yield call(fetchSignatureOssUrl, key)
    }
    yield put(pageLoaded())
  }
}

function* watchSkipApplicationPage() {
  while (true) {
    const { payload } = yield take('instructorApplication/skipApplicationPage')
    yield put(pageLoading())
    yield call(fetchInstructorApplication, payload)
    yield put(pageLoaded())
  }
}

function* watchOssSignature() {
  while (true) {
    const { payload } = yield take('ossSignature/getOssSignature')
    yield call(fetchOssSignature, payload)
  }
}

function* watchUploadPhoto() {
  while (true) {
    const { payload } = yield take('userPhoto/uploadPhoto')
    const { data, error } = yield call(fetchUploadPhoto, payload)
    if (error && error.status === 401) {
      const token = yield call(fetchRefreshToken)
      if (token.data) {
        setCookie('wechatToken', token.data.idToken, undefined, undefined, AUTH_COOKIE_MAX_AGE)
      }
      const { data } = yield call(fetchUploadPhoto, payload)
      if (data && data.success) {
        yield put(replace(window.location.pathname))
      }
    } else {
      if (data && data.success) {
        yield put(replace(window.location.pathname))
      }
    }
  }
}

function* watchRequestUserPhoto() {
  while (true) {
    const { payload } = yield take('userPhoto/getUserPhoto')
    yield call(fetchUserPhoto, payload)
  }
}

function* watchUploadSiFile() {
  while (true) {
    const { payload } = yield take('siAppDetail/uploadSifile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadSiFile, payload)
    if (data) yield call(fetchGetOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchUploadSiDetailAttach() {
  while (true) {
    const { payload } = yield take('siDetailInProcess/uploadDetailAttach')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadSiDetailAttach, payload)
    if (data) yield call(fetchGetDetailOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchSubmitSiInprocess() {
  while (true) {
    const { payload } = yield take('siDetailInProcess/submitInProcess')
    yield put(pageLoading())
    try {
      const result = yield call(fetchSubmitSiInprocess, payload)
      if (result && result.data) yield put(push('/siAppList'))
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchSubmitCdDetailSiInprocess() {
  while (true) {
    const { payload } = yield take('siDetailInProcess/submitCdDetailInProcess')
    yield put(pageLoading())
    try {
      const result = yield call(fetchReSubmitCdSiInprocess, payload)
      if (result && result.data) yield put(push('/cdAppList'))
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchSearchInstruetorInfo() {
  while (true) {
    const { payload } = yield take('studentInfo/getStudentInfo')
    try {
      yield put(pageLoading())
      yield call(fetchSearchInstructorInfo, payload.instructorNumber)
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchCdSubmitSiApp() {
  while (true) {
    const { data } = yield take(actions.CD_SUBMIT_SI)
    yield put(pageLoading())
    try {
      const result = yield call(fetchCdSubmitSiApp, data)
      if (result.data && result.data.code) yield put(push('/cdAppList'))
    } catch (error) {
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchUploadOwsiFile() {
  while (true) {
    const { payload } = yield take('applicantDetail/uploadOwsiFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadOwsiFile, payload)
    if (data) yield call(fetchGetOwsiOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchSkipOwsiCdApplicationPage() {
  while (true) {
    const { payload } = yield take('cdList/skipCdApplicationsPage')
    yield put(pageLoading())
    yield call(fetchOwsiCdList, payload)
    yield put(pageLoaded())
  }
}

function* watchUploadOwsiTrainingFile() {
  while (true) {
    const { payload } = yield take('owsiCdDetail/uploadTrainingRecords')
    yield put(pageLoading())
    const result = yield call(fetchUploadOwsiTraining, { formData: payload.formData })
    return
  }
}

function* watchRequestOwsiCdDetail() {
  while (true) {
    const { payload } = yield take('owsiCdDetail/requestOwsiCdDetail')
    yield put(pageLoading())
    try {
      const { data } = yield call(fetchOwsiCdDetail, payload)
      if (data) yield put(push(`/owsi_cd_app_detail?code=${payload.code}`))
    } catch (error) {
      console.error(error)
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchSubmitIe() {
  while (true) {
    const { payload } = yield take('ieCandidate/submitIeList')
    yield put(pageLoading())
    try {
      const { data } = yield call(fetchSubmitIe, payload)
      if (data && data.url) window.location.replace(data.url)
    } catch (error) {
      console.error(error)
      yield put(errorDialog())
    } finally {
      yield put(pageLoaded())
    }
  }
}

function* watchUploadEfriFile() {
  while (true) {
    const { payload } = yield take('efriDetail/uploadEfrOssFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadEfrOssFile, payload)
    if (data) yield call(fetchGetEfriOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchUploadEfrtFile() {
  while (true) {
    const { payload } = yield take('efrtDetail/uploadEfrtOssFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadEfrtOssFile, payload)
    if (data) yield call(fetchGetEfrtOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchSkipEfrtListPage() {
  while (true) {
    const { payload } = yield take('efrtList/skipEfrtApplicationsPage')
    yield put(pageLoading())
    yield call(fetchEfrtList, payload)
    yield put(pageLoaded())
  }
}

function* watchUploadBasicMermaidFile() {
  while (true) {
    const { payload } = yield take('basicMermaidDetail/uploadBasicMermaidOssFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadBasicMermaidFile, payload)
    if (data) yield call(fetchGetBasicMermaidOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchSkipBasicMermaidTListPage() {
  while (true) {
    const { payload } = yield take('basicMermaidTList/skipBasicMermaidTListPage')
    yield put(pageLoading())
    yield call(fetchBasicMermaidTList, payload)
    yield put(pageLoaded())
  }
}

function* watchSkipMermaidTListPage() {
  while (true) {
    const { payload } = yield take('mermaidTList/skipMermaidTListPage')
    yield put(pageLoading())
    yield call(fetchMermaidTList, payload)
    yield put(pageLoaded())
  }
}

function* watchUploadMermaidFile() {
  while (true) {
    const { payload } = yield take('mermaidDetail/uploadMermaidOssFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadMermaidFile, payload)
    if (data) yield call(fetchGetMermaidOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchUploadFdiFile() {
  while (true) {
    const { payload } = yield take('FDIDetail/uploadFDIOssFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadFdiFile, payload)
    if (data) yield call(fetchGetFdiOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchSkipFdiTListPage() {
  while (true) {
    const { payload } = yield take('FDITList/skipFDITListPage')
    yield put(pageLoading())
    yield call(fetchFdiTList, payload)
    yield put(pageLoaded())
  }
}

function* watchUploadAfdiFile() {
  while (true) {
    const { payload } = yield take('AFDIDetail/uploadAFDIOssFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadAfdiFile, payload)
    if (data) yield call(fetchGetAfdiOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchSkipAfdiTListPage() {
  while (true) {
    const { payload } = yield take('AFDITList/skipAFDITListPage')
    yield put(pageLoading())
    yield call(fetchAfdiTList, payload)
    yield put(pageLoaded())
  }
}

function* watchUploadMfdiFile() {
  while (true) {
    const { payload } = yield take('MFDIDetail/uploadMFDIOssFile')
    yield put(pageLoading())
    const { data } = yield call(fetchUploadMfdiFile, payload)
    if (data) yield call(fetchGetMfdiOssFile, data.url.replace('files.padi.com.cn/', ''))
    yield put(pageLoaded())
  }
}

function* watchSkipMfdiTListPage() {
  while (true) {
    const { payload } = yield take('MFDITList/skipMFDITListPage')
    yield put(pageLoading())
    yield call(fetchMfdiTList, payload)
    yield put(pageLoaded())
  }
}

function* watchRefreshProfiles() {
  while (true) {
    yield take(actions.REQUEST_PROFILES)
    // yield put(pageLoading())
    yield all([call(fetchEcards), call(fetchProfiles)])
    // yield put(pageLoaded())
  }
}

export default function* root() {
  yield all([
    fork(watchNavigate),
    fork(watchMobileCode),
    fork(watchVerifyMobile),
    fork(watchVerifyEmail),
    fork(watchEmailCode),
    fork(watchPostPassword),
    fork(watchShoppingCart),
    fork(watchDelectCartItem),
    fork(watchCredentialRequest),
    fork(watchReplaceCard),
    fork(watchGetYouzanMobileCode),
    fork(watchRequestHasPigYearCard),
    fork(watchToPigCard),
    fork(watchRequestShoppingCart),
    fork(watchSubmitMemberRenew),
    fork(watchSubmitStoreRenew),
    fork(watchRequestMemberRenew),
    fork(watchRequestCardOptionspage),
    fork(watchWechatUser),

    fork(watchRequestDmConfirmDetail),
    fork(watchInstructorApproved),
    fork(watchSubmitSignature),
    fork(watchSkipApplicationPage),
    fork(watchOssSignature),
    fork(watchRequestUserPhoto),
    fork(watchUploadSiFile),
    fork(watchUploadPhoto),
    fork(watchUploadSiDetailAttach),
    fork(watchSubmitSiInprocess),
    fork(watchSearchInstruetorInfo),
    fork(watchCdSubmitSiApp),
    fork(watchSubmitCdDetailSiInprocess),
    fork(watchUploadDmFile),
    fork(watchUploadInsDmFile),
    fork(watchUploadOwsiFile),
    fork(watchSkipOwsiCdApplicationPage),
    fork(watchRequestOwsiCdDetail),
    fork(watchPostProfile),
    fork(watchSubmitIe),
    fork(watchUploadOwsiTrainingFile),
    fork(watchUploadEfriFile),
    fork(watchUploadEfrtFile),
    fork(watchSkipEfrtListPage),
    fork(watchUploadBasicMermaidFile),
    fork(watchSkipBasicMermaidTListPage),
    fork(watchUploadMermaidFile),
    fork(watchSkipMermaidTListPage),
    fork(watchUploadFdiFile),
    fork(watchSkipFdiTListPage),
    fork(watchUploadAfdiFile),
    fork(watchSkipAfdiTListPage),
    fork(watchUploadMfdiFile),
    fork(watchSkipMfdiTListPage),
    fork(watchLoadEcards),
    fork(watchRefreshProfiles),
  ])
}
